import { useMemo } from 'react';

interface BuildInfo {
  commitSha: string;
  buildTime: string;
  isLovableEnv: boolean;
  displayVersion: string;
  displayBuildTime: string;
}

export const useBuildInfo = (): BuildInfo => {
  return useMemo(() => {
    const hostname = window.location.hostname;
    
    // Detectar ambiente Lovable
    const isLovableEnv = 
      hostname.includes('lovableproject.com') ||
      hostname.includes('preview--') ||
      hostname.includes('id-preview') ||
      hostname === 'localhost';
    
    // Valores do build (injetados pelo Vite)
    const commitSha = typeof __COMMIT_SHA__ !== 'undefined' 
      ? __COMMIT_SHA__ 
      : 'dev';
    const buildTime = typeof __BUILD_TIME__ !== 'undefined' 
      ? __BUILD_TIME__ 
      : new Date().toISOString();
    
    // Formatar para display
    const displayVersion = isLovableEnv 
      ? 'Lovable Preview' 
      : commitSha;
    
    const displayBuildTime = isLovableEnv
      ? 'Ambiente de desenvolvimento'
      : buildTime;
    
    return {
      commitSha,
      buildTime,
      isLovableEnv,
      displayVersion,
      displayBuildTime,
    };
  }, []);
};
